import {Component, OnInit} from '@angular/core';
import {
  QuarantinePlacementFormComponent
} from "@app/quarantine/quarantine-placement-form/quarantine-placement-form.component";
import {QuarantinePlacementFormInterface} from "@app/quarantine/intrfaces/quarantine.interface";
import {ActivatedRoute} from "@angular/router";
import {DataService} from "@app/shared/data.service";

@Component({
  selector: 'app-edit-quarantine-removal',
  templateUrl: './edit-quarantine-removal.component.html',
  styleUrls: ['./edit-quarantine-removal.component.scss'],
  standalone: true,
  imports: [
    QuarantinePlacementFormComponent
  ]
})
export class EditQuarantineRemovalComponent implements OnInit{
  constructor(
      private activatedRoute: ActivatedRoute,
      private dataService: DataService
  ) {}
  
  ngOnInit() {
    let breadcrumbs =  [...this.activatedRoute.snapshot.data['breadcrumbs']]
    let documentPlacement = history.state.quarantinePlacement
    
    let text = documentPlacement?.documentStatus === 'DRAFT' ?
        `Керувати зняттям з карантину №${history.state.quarantinePlacement?.id}` :
        `Зняття з карантину №${history.state.quarantinePlacement?.id}`
    
    breadcrumbs.push({title: text, link: ''});
    this.dataService.breadcrumbsArray.next(breadcrumbs)
  }
  
  config: QuarantinePlacementFormInterface = {
    documentType: 'QUARANTINE_REMOVAL',
    stage: "EDIT",
  }
}
